module.exports = __webpack_public_path__ + "static/4-c24c21abd333d2711e1c811c7221c9f8.jpg";